import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BulletinComponent } from '../../modals';
import { ButtonComponent } from '../../../../../shared/components';

@Component({
  selector: 'app-section-boletin',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './section-boletin.component.html',
  styleUrls: ['./section-boletin.component.scss'],
})
export class SectionBoletinComponent {
  constructor(private _modalService: NgbModal) {}

  openModalBulletin() {
    this._modalService.open(BulletinComponent, {
      centered: true,
      backdrop: 'static',
    });
  }
}
